// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker__input-container input {
  min-width: 100%; 
  padding: 0.5rem; 
  border: 1px solid #d1d5db;
  border-radius: 0.375rem; 
  box-sizing: border-box;
}

.react-datepicker-wrapper {
  min-width:100%;
}

.datafield {
  padding:20px;
  background:#f7f6f6;
}

.datafield h2 {
  font-size:.9em;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
  color:#fff;
  padding:10px 20px 10px 20px;
  margin:-20px -20px 20px -20px;

}

.datafield label {
  font-size:.85em;
  margin-bottom:5px;
}

span.required {
  color:#990000;
  font-weight: 900;
  font-size:1.3em;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;;AAE/B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".react-datepicker__input-container input {\n  min-width: 100%; \n  padding: 0.5rem; \n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem; \n  box-sizing: border-box;\n}\n\n.react-datepicker-wrapper {\n  min-width:100%;\n}\n\n.datafield {\n  padding:20px;\n  background:#f7f6f6;\n}\n\n.datafield h2 {\n  font-size:.9em;\n  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));\n  color:#fff;\n  padding:10px 20px 10px 20px;\n  margin:-20px -20px 20px -20px;\n\n}\n\n.datafield label {\n  font-size:.85em;\n  margin-bottom:5px;\n}\n\nspan.required {\n  color:#990000;\n  font-weight: 900;\n  font-size:1.3em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
